import { IComicNameListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

async function getComicNameList(): Promise<AxiosResponse<FetchResult<IComicNameListItem[]>>> {
  const response = await instance.get(`/comics`);
  return response;
}

const useFetchComicNameList = () => {
  const { data: originalData, refetch } = useQuery({
    queryKey: ['get', `/comics`],
    queryFn: () => getComicNameList(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: false
  });

  const data = originalData?.data.data;

  return { data, refetch };
};

export default useFetchComicNameList;
